<template>
  <div>
    <common-table
      :table-columns="tableColumns"
      :url="url"
      :operate="[]"
      :form-fields="formFields"
      pageName="selectionCartProduct"
      :permission="permission"
      :buttons="[]"
      :searchs="searchs" />
  </div>
</template>

<script>
import CommonTable from '@/components/CommonTable/CommonTable'

export default {
  name: 'SelectionCartProductList',
  components: { CommonTable },
  data() {
    return {
      searchs: [{
        name: 'agentId', placeholder: '代理', type: 'select', selectUrl: '/agent/getAll', selectData: []
      }, {
        name: 'keyword', placeholder: '商品标题', type: 'input'
      }, {
        name: 'source', placeholder: '商品来源', type: 'select', selectValue: [
          { key: 'rpa_douyin', value: '抖音RPA' }, { key: 'chanxuan', value: '蝉选' },
          { key: 'excel_import', value: 'Excel导入' }, { key: 'manual', value: '手工录入' }
        ]
      }, {
        name: 'status', placeholder: '提示词状态', type: 'select', selectValue: [
          { key: 'empty', value: '未生成' }, { key: 'ready', value: '待提交' }, { key: 'submitted', value: '已提交' }
        ]
      }, {
        name: 'doubaoWorkId', placeholder: '豆包作品ID', type: 'input'
      }],
      permission: { list: 'selectionCartProduct:list' },
      url: { get: '/selectionCartProduct/listByCondition' },
      formFields: { addTitle: '', updateTitle: '', model: [] },
      tableColumns: [{
        field: 'id', label: 'ID', show: true, width: '80'
      }, {
        field: 'productId', label: '商品ID', show: true
      }, {
        field: 'title', label: '商品标题', show: true, detail: true
      }, {
        field: 'price', label: '价格', show: true
      }, {
        field: 'commissionRate', label: '佣金率', show: true
      }, {
        field: 'source', label: '来源', show: true
      }, {
        field: 'sourceAccountName', label: '采集账号', show: true
      }, {
        field: 'userId', label: '用户ID', show: true, width: '100'
      }, {
        field: 'agentId', label: '代理', selectUrl: '/agent/getAll', selectData: [], show: { type: 'select' }
      }, {
        field: 'promptStatus', label: '提示词状态', show: { type: 'tag', tags: [
          { key: 'empty', value: '未生成', type: 'info' }, { key: 'ready', value: '待提交', type: 'warning' },
          { key: 'submitted', value: '已提交', type: 'success' }
        ] }
      }, {
        field: 'doubaoWorkId', label: '豆包作品ID', show: true
      }, {
        field: 'doubaoStatus', label: '豆包状态', show: { type: 'tag', tags: [
          { key: 'idle', value: '未入队', type: 'info' }, { key: 'queued', value: '待处理', type: 'warning' },
          { key: 'running', value: '处理中', type: 'warning' }, { key: 'success', value: '成功', type: 'success' },
          { key: 'fail', value: '失败', type: 'danger' }
        ] }
      }, {
        field: 'updatedAt', label: '更新时间', show: true
      }]
    }
  }
}
</script>
